export default "/images/f3049803e404b0c309df938316e52e3d.avif";